class CustomApiError extends Error {
    private data: any;
    public code?:number ;
    public title?:string ;
  
    constructor(message: string, customData: any,title?:string,code?:number ) {
      super(message);
      this.name = this.constructor.name;
      this.data = customData;
      this.title=title;
      this.code = code;
  
      Object.setPrototypeOf(this, CustomApiError.prototype);
    }
  
    getCustomData(): any {
      return this.data;
    }
  }
  
  export default CustomApiError;
  